import React from 'react';
import cls from './ValuesList.module.css';
import { ValueCard } from '../ValueCard/ValueCard';

export const ValuesList = ({ title, values }) => {
    return (
        <div className={cls.container}>
            <span className={cls.ValueListTitle}>{title}</span>
            {values.map((value) => (
                <ValueCard
                    value={value.value}
                    units={value.unit}
                    title={value.title}
                    type={value.type}
                    dimensionId={value.dimensionId ? value.dimensionId : null}
                    key={Math.random().toString(36)}
                />
            ))}
        </div>
    );
};
